/** @module i18n */

import { createI18n } from 'vue-i18n'
import { apiV1TranslationsPath, apiV1TranslationsPublicPath } from '@/../lib/routes'
import { apiCall } from '@/api'
import logger from '@/logger'

export const DEFAULT_LOCALE = 'en'

const i18n = createI18n({
  legacy: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE
})

/**
 * The [Vue I18n]{@link https://vue-i18n.intlify.dev} instance.
 *
 */
export default i18n

export async function loadMessages({
  _i18n = i18n,
  locale = DEFAULT_LOCALE,
  key = 'api',
  onlyPublic = false,
  setLocaleGlobally = true
} = {}) {
  try {
    if (onlyPublic) key = 'api.public'

    locale = locale || DEFAULT_LOCALE
    const rsp = await apiCall({
      path: onlyPublic ? apiV1TranslationsPublicPath() : apiV1TranslationsPath(),
      payload: { locale, key }
    })

    // NOTE: for `'composite'` mode (c.f. `legacy: false` above),
    // the `global.locale` property is a vue-ref,
    // and has to be set via `value`.
    //
    if (setLocaleGlobally) {
      _i18n.global.locale.value = locale
    }
    _i18n.global.setLocaleMessage(locale, {})
    const msgs = rsp.payload.data.attributes
    const mergeMsg = (key, msg) => {
      const m = {}
      let n = m
      key.split('.').forEach((k) => {
        n[k] = {}
        n = n[k]
      })
      Object.assign(n, msg)
      _i18n.global.mergeLocaleMessage(locale, m)
    }

    if (Array.isArray(key)) {
      msgs.forEach((msg, i) => {
        mergeMsg(key[i], msg)
      })
    } else {
      mergeMsg(key, msgs)
    }

    // load fallback locale
    if (locale !== DEFAULT_LOCALE) {
      loadMessages({ key, setLocaleGlobally: false, onlyPublic })
    }

    return msgs
  } catch (err) {
    logger.error(`Failed to load translations for ${locale}-locale and key ${key}`)
    logger.error(err)
  }
}
